import classNames from 'classnames';
import { ConversationPrompts } from 'utils/gloo-types';
import { format } from 'date-fns';
import { getTagColorFromStatus } from 'utils/conversationPrompts';
import Typography from 'components/atoms/Typography';
import Icon from 'components/atoms/Icon';
import Tag from 'components/atoms/Tag';
import { Dispatch, SetStateAction } from 'react';
import CloudinaryVideoPlayer from '../CloudinaryVideoPlayer';

interface ConversationPromptsListItemProps {
  prompt: ConversationPrompts;
  isSelected: boolean;
  setSelectedPrompt: Dispatch<SetStateAction<ConversationPrompts>>;
}

const ConversationPromptsListItem = ({ prompt, isSelected, setSelectedPrompt }: ConversationPromptsListItemProps) => {
  return (
    <button
      type="button"
      key={prompt.id}
      data-durable-id="conversationPromptListCard"
      data-intercom-target="conversationPromptListCard"
      onClick={() => setSelectedPrompt(isSelected ? null : prompt)}
      className={classNames('block w-full text-left rounded-sm px-4 py-8 hover:bg-glooNavy-50', {
        'bg-glooNavy-50': isSelected,
      })}
    >
      <div className="flex justify-between items-center mb-2">
        <Typography variant="label" className="mr-1">
          {prompt.name}
        </Typography>
        <Tag
          size="xs"
          text={prompt.status === 'Unpublished' ? 'Not Published' : prompt.status}
          color={getTagColorFromStatus(prompt.status)}
          icon={prompt.status === 'Published' ? 'check' : null}
        />
      </div>
      <Typography variant="base" className="mb-4 text-sm">
        {prompt.message}
      </Typography>
      {prompt.videoUrl && (
        <div className="my-2 flex flex-col items-start">
          <Typography variant="xs" className="mb-1">
            Video (this gets attached as a shortened URL when sending out the message)
          </Typography>
          <div
            onClick={(e) => {
              // Make sure clicking around the video doesn't trigger the card click
              e.stopPropagation();
            }}
          >
            <CloudinaryVideoPlayer
              config={{ file: { attributes: { preload: 'none' } } }}
              url={prompt.videoUrl}
              wrapClassName="max-h-48"
            />
          </div>
        </div>
      )}
      <div className="flex items-center text-neutral-600">
        {prompt.authorImageUrl && (
          <img src={prompt.authorImageUrl} alt={prompt.author} className="bg-white w-5 h-5 rounded-full mr-2" />
        )}
        <Typography variant="xs" className="mr-4">
          {prompt.author}
        </Typography>
        <Icon name="clock" size={12} className="mr-2" />
        <Typography variant="xs" className="mr-4">
          {format(new Date(prompt.updatedAt), 'MM/dd/yy h:mm a')}
        </Typography>
        <Icon name="tag" size={12} className="mr-2" />
        <Typography variant="xs" className="mr-4">
          {prompt.topics?.length}
        </Typography>
      </div>
    </button>
  );
};

export default ConversationPromptsListItem;
